// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.error-message-container[data-v-4819642a] {
  min-height: 1.7rem;
}
.fade-leave-to[data-v-4819642a],
.fade-enter-from[data-v-4819642a] {
  opacity: 0;
}
.fade-leave-active[data-v-4819642a],
.fade-enter-active[data-v-4819642a] {
  transition: opacity 0.3s ease;
}
`, "",{"version":3,"sources":["webpack://./html/src/lib/components/support/components/ValidationError.vue"],"names":[],"mappings":";AAmBA;EACE,kBAAkB;AACpB;AAEA;;EAEE,UAAU;AACZ;AACA;;EAEE,6BAA6B;AAC/B","sourcesContent":["<script setup>\ndefineProps({\n    msg: {\n        type: String,\n        default: \"\",\n    }\n});\n</script>\n\n\n<template>\n    <Transition name=\"fade\">\n        <small class=\"text-danger text-small\" v-if=\"msg\">\n            {{ msg }}\n        </small>\n    </Transition>\n</template>\n\n<style scoped>\n.error-message-container {\n  min-height: 1.7rem;\n}\n\n.fade-leave-to,\n.fade-enter-from {\n  opacity: 0;\n}\n.fade-leave-active,\n.fade-enter-active {\n  transition: opacity 0.3s ease;\n}\n</style>\n\n\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
